import React from "react";
import { Link } from "react-router-dom";
import Newsletter from "../components/Newsletter";

const Subscribe = () => {
	return (
		<section className='section pt-32 min-h-screen bg-gray-50'>
			<div className='container mx-auto px-4'>
				<Link to="/" className='inline-flex items-center text-blue-600 hover:text-blue-800 transition mb-8 font-medium'>
					← Back to Home
				</Link>
				<h1 className='text-4xl font-bold text-blue-900 text-center'>Subscribe</h1>
				<p className='text-gray-600 text-center mt-4'>Subscribe to Kohla News</p>
				<div className="mt-8 max-w-2xl mx-auto">
					<Newsletter />
				</div>
			</div>
		</section>
	);
};

export default Subscribe;